import { SelectFieldOption } from '@resurs-internal/mui/components/SelectField/SelectFieldOption';
import { useMemo } from 'react';

import useSettings from '../../hooks/useSettings';
import useTranslation from '../../hooks/useTranslation';
import SelectField from '../SelectField/SelectField';

type Props = {
    name: string;
    label: string;
};

const OccupationField = ({ name, label }: Props) => {
    const { countryCode } = useSettings();
    const translate = useTranslation();

    const occupationOptionsSE: SelectFieldOption[] = useMemo<SelectFieldOption[]>(
        () => [
            { id: 'EMPLOYEE', label: translate('field.occupation.option.employee') },
            { id: 'SUBSTITUTE', label: translate('field.occupation.option.substitute') },
            { id: 'SELF_EMPLOYED', label: translate('field.occupation.option.self-employed') },
            { id: 'PENSIONER', label: translate('field.occupation.option.pensioner') },
            { id: 'UNEMPLOYED', label: translate('field.occupation.option.unemployed') },
        ],
        [translate],
    );

    const occupationOptionsNO: SelectFieldOption[] = useMemo<SelectFieldOption[]>(
        () => [
            { id: 'EMPLOYEE', label: translate('field.occupation.option.employee') },
            { id: 'SUBSTITUTE', label: translate('field.occupation.option.substitute') },
            { id: 'SELF_EMPLOYED', label: translate('field.occupation.option.self-employed') },
            { id: 'PENSIONER', label: translate('field.occupation.option.pensioner') },
            { id: 'UNEMPLOYED', label: translate('field.occupation.option.unemployed') },
            { id: 'STUDENT', label: translate('field.occupation.option.student') },
            { id: 'DISABILITY_PENSIONER', label: translate('field.occupation.option.disability-pensioner') },
            { id: 'REHABILITATION', label: translate('field.occupation.option.rehabilitation') },
        ],
        [translate],
    );

    const occupationOptionsDK: SelectFieldOption[] = useMemo<SelectFieldOption[]>(
        () => [
            { id: 'EMPLOYEE', label: translate('field.occupation.option.employee') },
            { id: 'PENSIONER', label: translate('field.occupation.option.pensioner') },
            { id: 'STUDENT', label: translate('field.occupation.option.student') },
            { id: 'SELF_EMPLOYED', label: translate('field.occupation.option.self-employed') },
            { id: 'UNEMPLOYED', label: translate('field.occupation.option.unemployed') },
        ],
        [translate],
    );

    const showOptions = () => {
        switch (countryCode) {
            case 'NO':
                return occupationOptionsNO;
            case 'SE':
                return occupationOptionsSE;
            case 'DK':
                return occupationOptionsDK;
        }
    };

    return (
        <SelectField label={label} name={name}>
            {showOptions()}
        </SelectField>
    );
};

export default OccupationField;
